import { Link } from "react-router-dom";
import { CalendarIcon, HouseLineIcon, UserIcon } from "@phosphor-icons/react";

import StatusBadge from "./StatusBadge";

export default function WorkOrderCard({ wo, compact = false }) {
  const startsAt = wo.scheduled_start ? new Date(wo.scheduled_start) : null;
  return (
    <Link
      to={`/work-orders/${wo.id}`}
      data-testid={`work-order-card-${wo.id}`}
      className="block bg-white border border-slate-200 rounded-md p-3 hover:border-amber-300 hover:shadow-card transition-all"
    >
      <div className="flex items-center justify-between gap-2">
        <StatusBadge value={wo.status} />
        {startsAt && (
          <span className="text-[11px] text-slate-500 tabular flex items-center gap-1 font-medium">
            <CalendarIcon size={10} weight="bold" />
            {startsAt.toLocaleDateString()}{" "}
            {startsAt.toLocaleTimeString([], {
              hour: "2-digit",
              minute: "2-digit",
            })}
          </span>
        )}
      </div>
      <div className="mt-2 text-sm font-medium text-slate-900 truncate flex items-center gap-1.5">
        <HouseLineIcon
          size={12}
          weight="duotone"
          className="text-slate-400 shrink-0"
        />
        <span className="truncate">{wo.property_address || "—"}</span>
      </div>
      {!compact && wo.customer_name && (
        <div className="text-[11px] text-slate-500 mt-1 truncate">
          {wo.customer_name}
        </div>
      )}
      {(wo.assigned_lead_name || wo.assigned_assistant_name) && (
        <div className="mt-2 flex items-center gap-1 text-[11px] text-slate-600 truncate">
          <UserIcon size={10} weight="bold" className="shrink-0" />
          <span className="truncate">
            {wo.assigned_lead_name || "—"}
            {wo.assigned_assistant_name && (
              <span className="text-slate-400">
                {" "}
                + {wo.assigned_assistant_name}
              </span>
            )}
          </span>
        </div>
      )}
    </Link>
  );
}
